module.exports = __webpack_public_path__ + "static/media/galerija_2013 (31).b694eea8.jpg";